export const checkCreditCard = (cardNumber: string | undefined) => {
  if (cardNumber) {
    if (/[^0-9-\s]+/.test(cardNumber)) return false;
    const normalCardNumber = cardNumber.replace(/-/g, '');
    const arr = (normalCardNumber + '')
      .split('')
      .reverse()
      .map((x) => parseInt(x));
    const lastDigit = arr.splice(0, 1)[0];
    let sum = arr.reduce(
      (acc, val, i) =>
        i % 2 !== 0 ? acc + val : acc + ((val *= 2) > 9 ? val - 9 : val),
      0
    );
    sum += lastDigit;
    return sum % 10 === 0;
  }
  return false;
};
